<script lang="ts">
  import * as ramda from 'ramda';
  import type { Snippet } from 'svelte';
  import type { FormOptionsType } from '$shared/components/types';
  import type MonitorModel from '$provider/models/Monitor';

  import Monitor from '$shared/molecules/Monitor/Monitor.svelte';
  import VerificationInput from '$shared/molecules/VerificationInput/VerificationInput.svelte';
  import VerifyCheckbox from './VerifyCheckbox.svelte';
  import Disclaimers from './Disclaimers.svelte';
  import { Loader } from '$shared/components';

  interface Props {
    options?: FormOptionsType;
    verificationInputLoading?: boolean;
    customVerifyInput?: Snippet | undefined;
    onchange?: (newOptions: FormOptionsType) => void;
    onadd?: (param: any) => void;
  }

  let { options = {} as FormOptionsType, verificationInputLoading = false, customVerifyInput = undefined, onchange, onadd }: Props = $props();

  const dispatchChange = (newOptions: FormOptionsType): void => {
    onchange?.(newOptions);
  };

  const onVerifyCheckboxChange = (e: any): void => {
    const newOptions = ramda.clone(options);
    newOptions.verify.options.checked = e.target.checked;
    dispatchChange(newOptions);
  };

  const onMonitorChange = (monitor: MonitorModel): void => {
    const newOptions = ramda.clone(options);
    newOptions.monitor.options.config = monitor;
    dispatchChange(newOptions);
  };

  const onChangeAdditionalInput = (activeParamId: string): void => {
    const newOptions = ramda.clone(options);
    newOptions.verifyInput.options.additionalItemActive = activeParamId;
    dispatchChange(newOptions);
  };
</script>

<div class="comp-form-options">
  {#if options?.verify?.show}
    <div class="option">
      <VerifyCheckbox
        {...options?.verify.options}
        disabled={options.disabled || options?.verify?.options?.disabled}
        onchange={onVerifyCheckboxChange}
      />
      <Disclaimers list={options?.verify?.disclaimers} />
    </div>
  {/if}
  {#if options?.monitor?.show}
    <div class="option" class:has-verify-check={!!options?.verify?.show}>
      <Monitor
        option={options.monitor?.options}
        disabled={options.disabled ||
          !options?.verify?.options?.checked ||
          options.monitor?.options?.disabled}
        onchange={onMonitorChange}
      />
    </div>
  {/if}
  {#if options?.verifyInput?.show}
    <div class="option" class:move-top={options?.monitor?.show}>
      {#if verificationInputLoading}
        <div class="verification-input-loader">
          <Loader count={3} />
        </div>
      {:else}
        <VerificationInput
          {...options.verifyInput.options}
          disabled={options.verifyInput?.disabled || options.disabled}
          {onadd}
          onchangeadditionalinput={onChangeAdditionalInput}
        >
          {#snippet custom()}
            <div class="custom-verify">
              {@render customVerifyInput?.()}
            </div>
          {/snippet}
        </VerificationInput>
      {/if}
    </div>
  {/if}
</div>

<style>
  .comp-form-options {
    border-radius: 5px;
    padding-top: 16px;
  }
  .option {
    margin-top: -16px;
  }
  .option.move-top {
    margin-top: 20px;
  }
  .option.has-verify-check :global(.warn) {
    margin-top: 16px;
  }
  .verification-input-loader {
    margin-top: 30px;
  }
  .option.move-top .verification-input-loader {
    margin-top: unset;
  }
</style>
